import { motion } from "framer-motion";
import { Check, ArrowRight, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { WHY_CHOOSE_POINTS } from "@/data/capabilities";
import { COMPANY } from "@/data/site";

export default function WhyChooseSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-primary-deep section-padding px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="content-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
            <p className="label-overline text-gold-base mb-3">{t("whySkyMark")}</p>
            <h2 className="font-display font-extrabold text-white text-3xl md:text-4xl lg:text-5xl leading-tight mb-6">
              {t("builtForProjects")}
              <br />
              <span className="text-gold-base">{t("trustedByIndustry")}</span>
            </h2>
            <p className="text-white/60 leading-relaxed mb-8 max-w-md">{t("whyDescription")}</p>
            <div className="flex flex-wrap gap-3">
              <Link to="/contact" className="btn-white">
                {t("sendInquiry")}
                <ArrowRight className="w-4 h-4 ml-2" />
              </Link>
              <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-success/80 backdrop-blur-sm text-white font-body font-semibold text-sm transition-all duration-300 hover:bg-success">
                <MessageCircle className="w-4 h-4" />
                {t("whatsapp")}
              </a>
            </div>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {WHY_CHOOSE_POINTS.map((point, i) => (
              <motion.div
                key={point}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.4, delay: i * 0.08, ease: [0.25, 0.46, 0.45, 0.94] }}
                className="flex items-start gap-3 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4"
              >
                <div className="w-7 h-7 rounded-full bg-gold/20 flex items-center justify-center shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-gold" />
                </div>
                <p className="text-sm text-white/85 leading-snug">{point}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
